import { jsx as _jsx } from "react/jsx-runtime";
import { addNotification } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { NotificationUI } from './subcomponents/ui';
import { defaultClosableNotification, defaultNotification } from './types/notification';
/**
 * Component to display notifications either as inline or in the **Notification List** component.
 */
export const Notification = observer(props => {
    useEffect(() => {
        if (props.displayInline) {
            return;
        }
        addNotification(Object.assign(Object.assign(Object.assign({}, defaultClosableNotification), { actionButton: { show: false } }), props));
    }, [props]);
    // Let the Notification List render the notification.
    if (!props.displayInline) {
        return null;
    }
    return (_jsx(NotificationUI, Object.assign({}, defaultNotification, { actionButton: { show: false } }, props, { motionProps: {
            initial: 'out',
            animate: 'in',
            exit: 'out',
            variants: { in: { opacity: 1, x: 0 }, out: { opacity: 0, x: 25 } },
            layout: true,
            transition: { type: 'tween', duration: 0.3 }
        } })));
});
Notification.displayName = 'Notification';
//# sourceMappingURL=notification.js.map